import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const OfferManagementHelp = () => {
  const isMdScreen = IsMdScreen();

  return (
    <Stack direction="row" spacing={2}>
      <ShContainer maxWidth='xl' sx={{ flex: 1 }}>
        <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
          Offer Management
        </ResourceTypography>
        <ResourceTypography variant="body1" paragraph>
          Streamline your offer creation and management process with automated tools and templates.
          Create professional offers, track responses, and manage the onboarding process.
        </ResourceTypography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Offer Creation
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Create professional offer letters using customizable templates. Include compensation details,
          benefits, and other important information in a standardized format.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Offer Approval Workflow
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Set up approval workflows for offers based on role, department, or compensation level.
          Ensure all offers go through the proper review and approval process.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Offer Tracking
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Track the status of offers, including when they're sent, viewed, and accepted or declined.
          Follow up automatically with candidates who haven't responded.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Onboarding Integration
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Seamlessly transition from offer acceptance to onboarding. Automatically trigger
          onboarding tasks and paperwork when an offer is accepted.
        </Typography>

        <Box paddingTop={2} paddingBottom={3}>
          <ShButton
            component={RouterLink}
            to="/employer/settings/tools/offer-management"
            color="primary"
            variant="contained"
          >
            Configure Offer Settings
          </ShButton>
        </Box>
      </ShContainer>
      {!isMdScreen && <CommonQuestionSidebar />}
    </Stack>
  );
};

export default OfferManagementHelp; 